import { createContext, useContext } from 'react';

export const ChatContext = createContext({});

export const useChatContext = () => {
  const context = useContext(ChatContext);

  if (!context) throw new Error('useChatContext must be use inside ChatProvider');

  return context;
}
